import React, {Fragment, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getGradients} from "../../actions/gradientAction";
import Gradient from './Gradient';
import FullGradient from './FullGradient';
import Loader from '../layouts/Loader';
import {Grid} from '../../styles/Gradient-Styles.js';

const Gradients = () => {

    const dispatch = useDispatch();
    const gradients = useSelector((state) => state.gradient.gradients);
    const gradient = useSelector((state) => state.gradient.gradient);
    const isLoading = useSelector((state)=>state.gradient.isLoading);
    console.log(isLoading);
    useEffect(()=>{
        dispatch(getGradients());

    },[dispatch]);

    if(isLoading){
        return(
            <Loader/>
        )
    }
    else{
        return(
            <Fragment>
                {gradient && <FullGradient/>}
            <Grid>
                {
                    gradients.map(gradient=>
                    (<Gradient key={gradient._id} gradient={gradient} className="grid-item-custom"/>))
                }
            </Grid>
            </Fragment>
            );
    }
};

export default Gradients;